import React from "react";
import { useTranslation } from "react-i18next";
import handshake from "@/assets/benefits/handshake.svg";
import worldWideDelivery from "@/assets/benefits/worldWideDelivery.svg";
import exchange from "@/assets/benefits/exchange.svg";
import warranty from "@/assets/benefits/warranty.svg";
import styles from "./BenefitsList.module.scss";
import { useLayoutType, LayoutStyleTypes } from "@/util-react/layout";
import { Icon } from "@/elements-react/fix-icon";

export type BenefitsListType = LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;

export interface BenefitsListProps {
  type?: BenefitsListType;
}

export const BenefitsList: React.FC<BenefitsListProps> = ({ type = LayoutStyleTypes.TYPE_LG }) => {
  const { t } = useTranslation();
  const list = [
    { icon: handshake, text: t("01zmit608r1fv4zy.benefits-text-1", "10 years in the auto parts market") },
    { icon: warranty, text: t("crtuxg6deh132czh.benefits-text-4", "1 year warranty for all products") },
    { icon: worldWideDelivery, text: t("crtuxg6deh132czh.benefits-text-3", "Worldwide delivery") },
    { icon: exchange, text: t("crtuxg6deh132czh.benefits-text-5", "Free return or exchange within 14 days") },
  ];

  return (
    <div className={[styles.benefitsList, type === LayoutStyleTypes.TYPE_SM ? styles.benefitsListSm : styles.benefitsListLg].join(" ")}>
      {list.map((item, idx) => (
        <div key={idx} className={[styles.item, type === LayoutStyleTypes.TYPE_SM ? styles.itemSm : styles.itemLg].join(" ")}>
          <Icon src={item.icon} className={type === LayoutStyleTypes.TYPE_SM ? styles.iconSm : styles.iconLg} />
          <div className={[styles.text, type === LayoutStyleTypes.TYPE_SM ? styles.textSm : styles.textLg].join(" ")}>{item.text}</div>
        </div>
      ))}
    </div>
  );
};
